<header class="py-4">
  <div class="container">
    <div class="row align-items-center logo-background p-2">
      <div class="col-6">
        <img
          *ngIf="_logoService.logoUrl$ | async as logoUrl"
          loading="lazy"
          [src]="logoUrl"
          class="img-fluid rounded"
          width="300"
          onerror="this.style.display='none'"
          style="aspect-ratio: 3 / 1; object-fit: contain"
        />
      </div>
      <div class="col-6 text-end">
        <button
          class="btn btn-outline-primary btn-lg px-4 w-md"
          (click)="gotoLoginPage()"
        >
          {{variable.login}}
        </button>
      </div>
    </div>
  </div>
</header>
<div class="container" *ngIf="!isLogin">
  <div class="row justify-content-end">
    <div class="col-md-6 col-xl-4">
      <app-transaction-estimate
        [forTransactionPage]="false"
      ></app-transaction-estimate>
      <div class="text-center mt-3">
        <button
          class="btn btn-lg px-5 w-md send-money-btn"
          (click)="gotoLoginPage()"
        >
          {{variable.sendMoney}}
        </button>
      </div>
    </div>
  </div>
</div>
